import React from 'react';
import type { Locale } from '../../i18n';
import { t } from '../../i18n';

interface BrushPanelProps {
    isOpen: boolean;
    brushSize: number;
    setBrushSize: (size: number) => void;
    panelRef: React.RefObject<HTMLDivElement | null>;
    locale: Locale;
}

export const BrushPanel: React.FC<BrushPanelProps> = ({
    isOpen,
    brushSize,
    setBrushSize,
    panelRef,
    locale
}) => {
    return (
        <div 
            ref={panelRef}
            className={`
                absolute bottom-full mb-3 left-1/2 -translate-x-1/2 z-30 
                bg-slate-900/95 backdrop-blur-xl border border-slate-700/50 p-4 rounded-xl shadow-2xl 
                transition-all duration-300 origin-bottom
                flex flex-col gap-3 min-w-[200px]
                ${isOpen ? 'opacity-100 scale-100 translate-y-0' : 'opacity-0 scale-95 translate-y-4 pointer-events-none'}
            `}
        >
            <div className="flex justify-between items-center text-slate-300">
                <span className="text-xs font-medium">{t(locale, "brushSize")}</span>
                <span className="text-xs font-mono text-teal-400">{brushSize * 2 + 1}px</span>
            </div>
            <input 
                type="range" 
                min="0" 
                max="20" 
                step="1"
                value={brushSize}
                onChange={(e) => setBrushSize(parseInt(e.target.value))}
                className="w-full h-1.5 bg-slate-700 rounded-lg appearance-none cursor-pointer accent-teal-500"
            />
            <div className="flex justify-between text-[10px] text-slate-500 font-mono">
                <span>1px</span>
                <span>41px</span>
            </div>
        </div>
    );
};
